// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-add-page {
  width: 75%;
  display: block;
  margin: 5px auto;
}

.square_btn {
  text-align: center;
  padding: 7px 20px;
  border-radius: 25px;
  border: 1px solid #5ea1d8;
  text-decoration: none;
  color: #5ea1d8;
  background-image: linear-gradient(45deg, white 0%, white 100%);
  transition: 0.4s;
  font-family: "Raleway";
}

.square_btn:hover {
  color: white;
  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);
}

.square_btn {
  font-family: "Raleway";
  color: #5ea1d8;
}
.square_btn:hover {
  color: #fff;
}

.bundle-dialog {
  min-width: 320px;
  max-width: 420px;
  padding: 8px 0;
}
.bundle-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  position: relative;
}
.bundle-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 8px;
  align-items: center;
  color: #111827;
  flex: 1;
}
.bundle-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.bundle-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.bundle-dialog .dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.bundle-dialog .dialog-header .close-button:focus {
  outline: none;
}
.bundle-dialog .dialog-header .close-button:focus-visible {
  outline: none;
}
.bundle-dialog .dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bundle-dialog .dialog-content {
  padding: 16px 20px;
}
.bundle-dialog .dialog-content .subtitle {
  margin: 0 0 12px 0;
  color: #666;
  font-size: 13px;
}
.bundle-dialog .dialog-content button {
  display: flex;
  align-items: center;
  justify-content: center;
}

:host-context(body.theme-dark) .square_btn {
  background-image: linear-gradient(45deg, #1e293b 0%, #1e293b 100%) !important;
  -webkit-background-image: linear-gradient(45deg, #1e293b 0%, #1e293b 100%) !important;
  color: #7ab8e8 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .square_btn:hover {
  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%) !important;
  color: #fff !important;
}
:host-context(body.theme-dark) .bundle-dialog {
  background: #111827 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .bundle-dialog .dialog-header {
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .bundle-dialog .dialog-header h2 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .bundle-dialog .dialog-header .close-button {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bundle-dialog .dialog-header .close-button:hover {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .bundle-dialog .dialog-header .close-button mat-icon {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bundle-dialog .dialog-content .subtitle {
  color: #94a3b8 !important;
}

::ng-deep .create-flow-type-menu {
  min-width: 200px;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-content {
  padding: 8px 0;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  font-family: "Raleway";
  font-weight: 500;
  position: relative;
  padding-right: 96px;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item mat-icon {
  color: #5ea1d8;
  font-size: 20px;
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  transition: color 0.2s ease;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item span {
  font-size: 14px;
  color: #111827;
  position: relative;
  z-index: 1;
  transition: color 0.2s ease;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item .menu-badge {
  position: absolute;
  top: 6px;
  right: 8px;
  z-index: 2;
  margin-left: 0;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background: #e83e8c;
  color: #ffffff !important;
  border: none;
  line-height: 1.2;
  box-shadow: 0 1px 4px rgba(232, 62, 140, 0.3);
  pointer-events: none;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item:before {
  content: "";
  width: 2px;
  height: 100%;
  top: 0px;
  left: 0px;
  background: #5ea1d8;
  position: absolute;
  transition: width 0.25s ease-in-out;
  z-index: 0;
  border-radius: 0 4px 4px 0;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused {
  background: transparent;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover:before, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted:before, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused:before {
  width: 100%;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover mat-icon, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted mat-icon, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused mat-icon {
  color: #fff;
}
::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover span, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted span, ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused span {
  color: #fff;
}

body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-content {
  background: #111827 !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item {
  color: #f3f4f6 !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item mat-icon {
  color: #7ab8e8 !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item span {
  color: #f3f4f6 !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item .menu-badge.paid {
  background: #e83e8c !important;
  color: #ffffff !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused {
  background: transparent !important;
  color: #fff !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover:before, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted:before, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused:before {
  background: #5ea1d8 !important;
  width: 100% !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover mat-icon, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted mat-icon, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused mat-icon {
  color: #fff !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover span, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted span, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused span {
  color: #fff !important;
}
body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item:hover .menu-badge.paid, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.mat-mdc-menu-item-highlighted .menu-badge.paid, body.theme-dark ::ng-deep .create-flow-type-menu .mat-mdc-menu-item.cdk-program-focused .menu-badge.paid {
  background: #e83e8c !important;
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/bundledialog/bundledialog.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EAEA,8DAAA;EAEA,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,YAAA;EAEA,kEAAA;AAAF;;AAGA;EACE,sBAAA;EACA,cAAA;AAAF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AAAJ;AAEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,OAAA;AAAN;AAGI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AADN;AAGM;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AADR;AAIM;EACE,mBAAA;EACA,sBAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAMM;EACE,aAAA;AAJR;AAOM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALR;AAUE;EACE,kBAAA;AARJ;AAUI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AARN;AAWI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AATN;;AAeE;EACE,6EAAA;EACA,qFAAA;EACA,yBAAA;EACA,gCAAA;AAZJ;AAcI;EACE,6EAAA;EACA,sBAAA;AAZN;AAgBE;EACE,8BAAA;EACA,yBAAA;AAdJ;AAgBI;EACE,yDAAA;AAdN;AAgBM;EACE,yBAAA;AAdR;AAiBM;EACE,yBAAA;AAfR;AAiBQ;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAfV;AAkBQ;EACE,yBAAA;AAhBV;AAsBM;EACE,yBAAA;AApBR;;AA2BA;EACE,gBAAA;AAxBF;AA0BE;EACE,cAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;AAzBN;AA4BI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;AA1BN;AA6BI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;EACA,oBAAA;AA3BN;AA8BI;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,UAAA;EACA,0BAAA;AA5BN;AA+BI;EAGE,uBAAA;AA/BN;AAiCM;EACE,WAAA;AA/BR;AAkCM;EACE,WAAA;AAhCR;AAmCM;EACE,WAAA;AAjCR;;AAwCE;EACE,8BAAA;AArCJ;AAwCE;EACE,yBAAA;AAtCJ;AAwCI;EACE,yBAAA;AAtCN;AAyCI;EACE,yBAAA;AAvCN;AA0CI;EACE,8BAAA;EACA,yBAAA;AAxCN;AA2CI;EAGE,kCAAA;EACA,sBAAA;AA3CN;AA6CM;EACE,8BAAA;EACA,sBAAA;AA3CR;AA8CM;EACE,sBAAA;AA5CR;AA+CM;EACE,sBAAA;AA7CR;AAgDM;EACE,8BAAA;EACA,yBAAA;AA9CR","sourcesContent":[".btn-add-page {\n  width: 75%;\n  display: block;\n  margin: 5px auto;\n}\n\n.square_btn {\n  text-align: center;\n  padding: 7px 20px;\n  border-radius: 25px;\n  border: 1px solid #5ea1d8;\n  text-decoration: none;\n  color: #5ea1d8;\n  background-image: -webkit-linear-gradient(45deg, white 0%, white 100%);\n  background-image: linear-gradient(45deg, white 0%, white 100%);\n\n  transition: 0.4s;\n  font-family: \"Raleway\";\n}\n\n.square_btn:hover {\n  color: white;\n  background-image: -webkit-linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n}\n\n.square_btn {\n  font-family: \"Raleway\";\n  color: #5ea1d8;\n  &:hover {\n    color: #fff;\n  }\n}\n\n.bundle-dialog {\n  min-width: 320px;\n  max-width: 420px;\n  padding: 8px 0;\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e9ecef;\n    position: relative;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      display: flex;\n      gap: 8px;\n      align-items: center;\n      color: #111827;\n      flex: 1;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 40px;\n      height: 40px;\n      min-width: 40px;\n      min-height: 40px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s ease;\n      background: transparent;\n      border: 1px solid transparent;\n      padding: 0;\n      margin: 0;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n        border-color: #e5e7eb;\n      }\n\n      &:active {\n        background: #e5e7eb;\n        transform: scale(0.95);\n      }\n\n      &:focus {\n        outline: none;\n      }\n\n      &:focus-visible {\n        outline: none;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .dialog-content {\n    padding: 16px 20px;\n\n    .subtitle {\n      margin: 0 0 12px 0;\n      color: #666;\n      font-size: 13px;\n    }\n\n    button {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .square_btn {\n    background-image: linear-gradient(45deg, #1e293b 0%, #1e293b 100%) !important;\n    -webkit-background-image: linear-gradient(45deg, #1e293b 0%, #1e293b 100%) !important;\n    color: #7ab8e8 !important;\n    border-color: #5ea1d8 !important;\n\n    &:hover {\n      background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%) !important;\n      color: #fff !important;\n    }\n  }\n\n  .bundle-dialog {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n\n    .dialog-header {\n      border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n\n      h2 {\n        color: #f3f4f6 !important;\n      }\n\n      .close-button {\n        color: #94a3b8 !important;\n\n        &:hover {\n          background: #1e293b !important;\n          color: #f3f4f6 !important;\n          border-color: rgba(148, 163, 184, 0.35) !important;\n        }\n\n        mat-icon {\n          color: #94a3b8 !important;\n        }\n      }\n    }\n\n    .dialog-content {\n      .subtitle {\n        color: #94a3b8 !important;\n      }\n    }\n  }\n}\n\n// Create Flow Type Menu Styles - Match profile menu style\n::ng-deep .create-flow-type-menu {\n  min-width: 200px;\n\n  .mat-mdc-menu-content {\n    padding: 8px 0;\n  }\n\n  .mat-mdc-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    font-family: \"Raleway\";\n    font-weight: 500;\n    position: relative;\n    padding-right: 96px;\n\n    mat-icon {\n      color: #5ea1d8;\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      position: relative;\n      z-index: 1;\n      transition: color 0.2s ease;\n    }\n\n    span {\n      font-size: 14px;\n      color: #111827;\n      position: relative;\n      z-index: 1;\n      transition: color 0.2s ease;\n    }\n\n    .menu-badge {\n      position: absolute;\n      top: 6px;\n      right: 8px;\n      z-index: 2;\n      margin-left: 0;\n      padding: 0.2rem 0.55rem;\n      border-radius: 999px;\n      font-size: 0.62rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n      background: #e83e8c;\n      color: #ffffff !important;\n      border: none;\n      line-height: 1.2;\n      box-shadow: 0 1px 4px rgba(232, 62, 140, 0.3);\n      pointer-events: none;\n    }\n\n    &:before {\n      content: \"\";\n      width: 2px;\n      height: 100%;\n      top: 0px;\n      left: 0px;\n      background: #5ea1d8;\n      position: absolute;\n      transition: width 0.25s ease-in-out;\n      z-index: 0;\n      border-radius: 0 4px 4px 0;\n    }\n\n    &:hover,\n    &.mat-mdc-menu-item-highlighted,\n    &.cdk-program-focused {\n      background: transparent;\n\n      &:before {\n        width: 100%;\n      }\n\n      mat-icon {\n        color: #fff;\n      }\n\n      span {\n        color: #fff;\n      }\n    }\n  }\n}\n\nbody.theme-dark ::ng-deep .create-flow-type-menu {\n  .mat-mdc-menu-content {\n    background: #111827 !important;\n  }\n\n  .mat-mdc-menu-item {\n    color: #f3f4f6 !important;\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n\n    span {\n      color: #f3f4f6 !important;\n    }\n\n    .menu-badge.paid {\n      background: #e83e8c !important;\n      color: #ffffff !important;\n    }\n\n    &:hover,\n    &.mat-mdc-menu-item-highlighted,\n    &.cdk-program-focused {\n      background: transparent !important;\n      color: #fff !important;\n\n      &:before {\n        background: #5ea1d8 !important;\n        width: 100% !important;\n      }\n\n      mat-icon {\n        color: #fff !important;\n      }\n\n      span {\n        color: #fff !important;\n      }\n\n      .menu-badge.paid {\n        background: #e83e8c !important;\n        color: #ffffff !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
